import { useState, useEffect, useMemo } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";
import { extractPayloadFieldsManual } from "../utils/payloadSchemaManual";

/**
 * Catalogue condition-fields pour un type de transaction (règles).
 * GET /admin/rules/ui-options/condition-fields?transaction_type=...
 */
export function useRuleConditionFields(brandName, transactionType) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName || !transactionType) {
            setCatalog(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        const url = `${LOYALTY_API_BASE}/admin/rules/ui-options/condition-fields?transaction_type=${encodeURIComponent(transactionType)}`;
        loyaltyFetch(url, { headers: { "X-Brand": brandName } })
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => { if (!cancelled) setCatalog(data); })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName, transactionType]);

    const payloadFields = useMemo(() => {
        if (Array.isArray(catalog?.payloadFields)) return catalog.payloadFields;
        return [];
    }, [catalog]);

    const payloadPaths = useMemo(() => {
        if (payloadFields.length > 0) {
            return payloadFields.map((f) => f.name || f.earnPointsPath).filter(Boolean);
        }
        const fromSources = catalog?.sources?.payload;
        if (Array.isArray(fromSources)) {
            return fromSources.map((p) => String(p).replace(/^payload\./, ""));
        }
        return [];
    }, [catalog, payloadFields]);

    const hasPayloadSchema = useMemo(() => payloadPaths.length > 0, [payloadPaths]);

    return {
        catalog,
        loading,
        ruleHints: catalog?.ruleHints || null,
        payloadFields,
        payloadPaths,
        hasPayloadSchema,
        fieldMeta: catalog?.fieldMeta || {},
        valuePresets: catalog?.valuePresets || {},
    };
}

export default useRuleConditionFields;
